import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	priorityHeader: {
		id: 'servicedesk-sla-settings.metrics.metric.metric-view.goals.goal.priority-header',
		defaultMessage: 'And priority is:',
		description: 'Priority subgoals header',
	},
	allMatchingPriorities: {
		id: 'servicedesk-sla-settings.metrics.metric.metric-view.goals.goal.all-matching-priorities',
		defaultMessage: 'All matching priorities',
		description: 'Text for the default subgoal when subgoals are not present',
	},
	allRemainingPriorities: {
		id: 'servicedesk-sla-settings.metrics.metric.metric-view.goals.goal.all-remaining-priorities',
		defaultMessage: 'All remaining priorities',
		description: 'Text for the default subgoal when subgoals are present',
	},
});
